import {
  Card,
  CardContent,
  CardHeader,
  Grid2 as Grid,
  Skeleton,
} from '@mui/material';

export default function MetricCardSkeleton() {
  return (
    <Card elevation={2}>
      <CardHeader
        title={<Skeleton variant="text" width="60%" height={24} />}
        avatar={<Skeleton variant="circular" width={40} height={40} />}
      />
      <CardContent>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          <Grid size="auto">
            <Skeleton variant="circular" width={32} height={32} />
          </Grid>
          <Grid size="auto">
            <Skeleton variant="text" width={80} height={40} />
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <Grid container justifyContent="center" alignItems="center" spacing={1}>
          <Grid size="auto">
            <Skeleton variant="circular" width={20} height={20} />
          </Grid>
          <Grid size="auto">
            <Skeleton variant="text" width={60} height={20} />
          </Grid>
          <Grid size="auto">
            <Skeleton variant="text" width={100} height={20} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
